export enum CellErrorTypes {
  InvalidDate = '__Invalid Date',
  UnexpectedValue = '__Unexpected Value'
}

export const cellErrorTypeText: Record<CellErrorTypes, string> = {
  [CellErrorTypes.InvalidDate]: 'Invalid Date',
  [CellErrorTypes.UnexpectedValue]: 'Unexpected Value'
};
